import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { IAuroraState } from '@apps/aurora.state';
import { Tag } from '@apps/cmdb/models';
import * as fromCmdbStore from '@apps/cmdb/store';
import { PopinModalService } from '@ui/misc/popin-modal/popin-modal.service';
import { CreateTagComponent } from '@customer/cmdb/tags/tag-edit/create-tag/create-tag.component';

@Component({
    selector: 'aa-chips-tag-input',
    templateUrl: './chips-tag-input.component.html',
    styleUrls: [
        './chips-tag-input.component.scss'
    ],
    standalone: false
})
export class ChipsTagInputComponent implements OnInit, OnChanges
{
    @Input() tags: Tag[];
    @Input() public disabled = false;
    @Input() public placeholder: string = 'Click to assign a tag';
    @Output() public attachTagEvent: EventEmitter<string> = new EventEmitter();
    @Output() public createTagEvent: EventEmitter<void> = new EventEmitter();
    public formGroup: UntypedFormGroup;
    public readonly ctrlFullTag: UntypedFormControl = new UntypedFormControl();
    public availableTags: Observable<Tag[]>;
    public selectedTagId: string;

    constructor (
        private store: Store<IAuroraState>,
        private popinModalService: PopinModalService
    )
    {
    }

    ngOnInit ():void
    {
        this.formGroup = new UntypedFormGroup({
            ctrlFullTag: this.ctrlFullTag
        });
    }

    ngOnChanges (): void
    {
        this.availableTags = this.store
            .select(fromCmdbStore.getTagsByNotIds, { tagIds: this.tags.map((t: Tag) => t.tagId) });
    }

    public onClick (tagId: string):void
    {
        this.selectedTagId = tagId;
        this.onSubmit();
    }

    public onCreate ():void
    {
        this.popinModalService.create(
            CreateTagComponent,
            {
                width: 52,
                hasBackdrop: false
            }
        );
    }

    private onSubmit (): void
    {
        if (this.selectedTagId)
        {
            this.attachTagEvent.emit(this.selectedTagId);
            this.formGroup.get('ctrlFullTag').setValue('');
        }
    }
}
